import React, { Component } from 'react'
import uuidv4 from 'uuid/v4'

import AnswerItem from '~/components/AnswerItem'
import { getAnswersByDynId } from '~/services'
import styles from './index.css'

const EXTRA_QUERY_MAP = {
  normal: {},
  award: { awards: 1 },
}

const EMPTY_STATE_MAP = {
  normal: '暂无相关讨论',
  award: '获奖讨论即将揭晓，快来参与！',
}

export default class AnswerList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      answers: [],
      remainingHeight: document.body.offsetHeight,
      pageSize: 20,
    }
  }

  componentDidMount = () => {
    this.loadData()
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.dynamicId !== nextProps.dynamicId ||
      this.props.answerType !== nextProps.answerType
    ) {
      this.setState(
        {
          ...this.state,
          answers: [],
          pageSize: 20,
        },
        this.loadData
      )
    }
  }

  loadData = () => {
    const { dynamicId, answerType, onChange } = this.props

    if (!dynamicId) return

    const { pageSize, answers: oldAnswers } = this.state
    const remainder = oldAnswers.length % pageSize
    const pageNum = remainder
      ? Math.ceil(oldAnswers.length / pageSize)
      : oldAnswers.length / pageSize + 1

    this.setState({ isLoading: true })

    getAnswersByDynId({
      activityDynamicId: dynamicId,
      pageSize,
      pageNum,
      ...EXTRA_QUERY_MAP[answerType],
    })
      .then(({ data } = {}) => {
        this.setState({
          isLoading: false,
          answers: oldAnswers
            .splice(0, oldAnswers.length - remainder)
            .concat(data.pageDate),
        })

        if (onChange) onChange(data)
      })
      .catch(() => {
        this.setState({ isLoading: false })
      })
  }

  handleScroll = () => {
    const { isLoading, remainingHeight } = this.state

    if (isLoading) {
      return
    }

    const { scrollHeight, clientHeight, scrollTop } = document.body
    const newRemainingHeight =
      scrollHeight -
      clientHeight -
      (document.documentElement.scrollTop || scrollTop)

    this.setState({ remainingHeight: newRemainingHeight }, () => {
      if (remainingHeight >= 42 && newRemainingHeight < 42) {
        this.loadData()
      }
    })
  }

  render() {
    const { isLoading, answers = [] } = this.state
    const { answerType, combineProductToken } = this.props

    if (!answers.length && !isLoading) {
      return (
        <div className={styles.answerListEmpty}>
          {EMPTY_STATE_MAP[answerType]}
        </div>
      )
    }

    return (
      <div className={styles.answerList}>
        {answers.map(item => {
          return (
            <AnswerItem
              key={`answeritem_${uuidv4()}`}
              {...item}
              combineProductToken={combineProductToken}
            />
          )
        })}
        {isLoading && <div className={styles.answerListLoading}>加载中...</div>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/AnswerList/index.js